// src/components/page/home/TeacherScheduleView.jsx
import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
import ScheduleTableDisplay from './ScheduleTableDisplay';

const TeacherScheduleView = ({
  filteredArr,
  teacherDataReady,
  lastStableTeacherSchedulesRef,
  viewMode,
  ViewModes,
  teacherViewScope,
  TeacherViewScopes,
  groupModes,
  selectedDate,
  selectedTeacher,
}) => {

  // якщо викладача НЕ обрано і кеш порожній — показуємо заглушку
  if (!selectedTeacher && lastStableTeacherSchedulesRef.current.length === 0) {
    return (
      <motion.div className="text-center py-12">
        <AlertTriangle className="mx-auto h-16 w-16 text-accent mb-4" />
        <p className="text-xl font-semibold text-muted-foreground">Оберіть викладача для перегляду розкладу</p>
      </motion.div>
    );
  }

  // якщо викладача обрано, але дані ще вантажаться — показуємо кеш (якщо є)
  if (!teacherDataReady) {
    return (
      <ScheduleTableDisplay
        schedules={lastStableTeacherSchedulesRef.current}
        viewMode={viewMode}
        ViewModes={ViewModes}
        teacherViewScope={teacherViewScope}
        TeacherViewScopes={TeacherViewScopes}
        groupModes={groupModes}
        selectedDate={selectedDate}
      />
    );
  }

  // Якщо вантаження завершилось і даних нема — показуємо заглушку
  if (teacherDataReady && filteredArr.length === 0) {
    return (
      <motion.div className="text-center py-12">
        <AlertTriangle className="mx-auto h-16 w-16 text-accent mb-4" />
        <p className="text-xl font-semibold text-muted-foreground">Немає занять для цього викладача</p>
      </motion.div>
    );
  }

  // Якщо є дані — показуємо їх
  return (
    <ScheduleTableDisplay
      schedules={filteredArr.length ? filteredArr : lastStableTeacherSchedulesRef.current}
      viewMode={viewMode}
      ViewModes={ViewModes}
      teacherViewScope={teacherViewScope}
      TeacherViewScopes={TeacherViewScopes}
      groupModes={groupModes}
      selectedDate={selectedDate}
    />
  );
};

export default TeacherScheduleView;
